export enum QuestionType {

    ContactDetails = 'contactDetails',
    Question = 'question',
    Images = 'images',
    Completed = 'completed',

}
